module.exports = __webpack_public_path__ + "images/emoji/postal_horn.a414ca5de607e8222f11.png";